import oilPaintingImage from "@/assets/style-oil-painting.jpg";
import watercolorImage from "@/assets/style-watercolor.jpg";
import animationImage from "@/assets/style-disney.jpg";

export type ApprovedProofSource = "demo" | "customer_consented";

export type ApprovedProofItem = {
  id: string;
  source: ApprovedProofSource;
  surfaceApproval: "homepage" | "style-page" | "homepage-and-style-page";
  title: string;
  styleLabel: string;
  scenario: string;
  displayName: string;
  quote?: string;
  imageSrc: string;
  imageAlt: string;
  styleIds: string[];
  consentReference?: string;
};

const demoProofItems = [
  {
    id: "demo-family-oil-painting",
    source: "demo",
    surfaceApproval: "homepage-and-style-page",
    title: "Portrait de famille en peinture à l'huile",
    styleLabel: "Peinture à l'huile",
    scenario: "Cadeau familial",
    displayName: "Exemple démo",
    quote: "Un rendu chaleureux pour projeter une photo de famille en tableau de salon.",
    imageSrc: oilPaintingImage,
    imageAlt: "Exemple démo de portrait de famille transformé en peinture à l'huile",
    styleIds: ["oil-painting"],
  },
  {
    id: "demo-watercolor-memory",
    source: "demo",
    surfaceApproval: "homepage-and-style-page",
    title: "Souvenir lumineux en aquarelle",
    styleLabel: "Aquarelle",
    scenario: "Naissance ou anniversaire",
    displayName: "Exemple démo",
    quote: "Une option douce pour tester une photo claire avant impression.",
    imageSrc: watercolorImage,
    imageAlt: "Exemple démo de photo transformée en aquarelle personnalisée",
    styleIds: ["watercolor"],
  },
  {
    id: "demo-pet-animation",
    source: "demo",
    surfaceApproval: "homepage-and-style-page",
    title: "Animal de compagnie en animation 3D",
    styleLabel: "Animation 3D",
    scenario: "Portrait animal",
    displayName: "Exemple démo",
    quote: "Un exemple ludique pour imaginer un chien ou un chat en tableau personnalisé.",
    imageSrc: animationImage,
    imageAlt: "Exemple démo de portrait animal transformé en style animation 3D",
    styleIds: ["disney", "anime"],
  },
] satisfies ApprovedProofItem[];

const consentedProofItems = [] satisfies ApprovedProofItem[];

export const approvedProofItems = [...demoProofItems, ...consentedProofItems] satisfies ApprovedProofItem[];

export const publicApprovedProofItems = approvedProofItems.filter(
  (item) => item.source === "demo" || Boolean(item.consentReference),
);

export const getApprovedProofItemsForHomepage = () =>
  publicApprovedProofItems.filter(
    (item) => item.surfaceApproval === "homepage" || item.surfaceApproval === "homepage-and-style-page",
  );

export const getApprovedProofItemsForStyle = (styleId: string) =>
  publicApprovedProofItems.filter(
    (item) =>
      item.styleIds.includes(styleId) &&
      (item.surfaceApproval === "style-page" || item.surfaceApproval === "homepage-and-style-page"),
  );
